import { AppStatus } from "./Types";


export function isAppStatus(status: string | AppStatus): status is AppStatus {

    // translate it if possible

    const acceptableStatuses: AppStatus[] = [
        "In Review",
        "Live",
        "Ready for Install",
        "Submitted For Review",
        "Submitted for Review",
        "Requires Attention",
        "Incomplete",
        "Other",
        "Cancelled",
        "Archived"
    ]

    if (acceptableStatuses.includes(status as AppStatus)) {
        return true;
    }

    return false;

}